import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const UserGlyph = /*#__PURE__*/createElement("g", {
  id: "user"
}, /*#__PURE__*/createElement("path", {
  d: "M64.1,58.1c-1-10-8.1-17.9-17.5-19.9c1.6-0.6,3-1.5,4.2-2.7c2.4-2.3,3.7-5.5,3.7-8.8c0-6.8-5.4-12.4-12.2-12.5 c-3.5,0-6.7,1.2-9.1,3.6c-2.4,2.3-3.7,5.4-3.7,8.8c0,5.3,3.3,9.8,7.9,11.6c-8.4,1.8-15.2,8.4-17.1,17.4c-1.3,6.2,0.4,9.4,6.3,11.8 c5.4,2.1,11,2.4,15.3,2.5h0c0.3,0,0.6,0,0.9,0c0.3,0,0.6,0,0.9,0c0.4,0,0.8,0,1.2,0c4.8-0.4,9.8-0.9,14.5-3.4 C62.9,64.5,64.4,61.7,64.1,58.1z M32.5,26.6c0-2.5,1-4.9,2.8-6.7c1.8-1.8,4.2-2.8,6.8-2.8c0,0,0.1,0,0.1,0c5.1,0.1,9.2,4.3,9.2,9.5 c0,2.6-1,4.9-2.8,6.7c-1.8,1.8-4.2,2.7-6.7,2.7h0C36.7,36,32.5,31.8,32.5,26.6z M58,63.7c-4.1,2.2-8.8,2.7-13.3,3.1 c-0.6,0-1.2,0-1.8,0c-0.3,0-0.6,0-0.9,0c-4,0-9.3-0.3-14.2-2.2c-4.6-1.8-5.5-3.6-4.5-8.4c2-9.5,10.2-16,19.6-15.5 c9.6,0.5,17.2,7.9,18.2,17.7C61.3,60.8,60.4,62.4,58,63.7z"
}));
const User = createSvg({
  name: 'user',
  path: UserGlyph
});

export default User;
export { UserGlyph };
